<script>
/**
   * @overview 游戏编辑
   *
   * @author huojinzhao
   */

import mapUtils, { $form, $http } from "@/utils";
import SpeakConfig from "./config/SpeakConfig.vue";
import ListenConfig from "./config/ListenConfig.vue";
import TrueOrFalseConfig from "./config/TrueOrFalseConfig.vue";
import SpellConfig from "./config/SpellConfig.vue";
import PlayConfig from "./config/PlayConfig.vue";

export default {
  name: "ListConfigEditor",
  components: {
    SpeakConfig,
    ListenConfig,
    TrueOrFalseConfig,
    SpellConfig,
    PlayConfig,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: [String, Number],
      required: true,
    },
    typeTwo: {
      type: [String, Number],
    },
    data: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    formData: null,
    options: [],
    outsource: {
      name: "",
      url: "",
    },
    game_selected: {
      select_text: "",
      select_img: "",
      question_number: "",
      option_number: "",
      question_type: "",
    },
    recorder: {
      name: "",
      config: [],
    },
    loading: {
      submit: false,
    },
    // rules: {
    //   name: [
    //     $form.rules.required('游戏名称'),
    //   ],
    //   game_pack_id: [
    //     $form.rules.required('游戏包', 'number', 'change'),
    //   ],
    //
    // },
  }),

  computed: {
    isOutsource() {
      return this.type !== 1;
    },
    isCreate() {
      return !this.data;
    },
    gameInit() {
      return this.isOutsource ? this.outsource : this.recorder;
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.init();
      } else {
        this.formData = null;
      }
    },
  },
  methods: {
    ...mapUtils("form", ["submit", "errorAlert"]),
    init() {
      const self = this;
      const data = this.data || this.gameInit;
      this.formData = { type: this.typeTwo || this.type, ...data };
      $http.get("/game_pack?per_page=9999")
        .then((res) => {
          let typeData = res.data.filter(item => `${item.game_type}` === `${self.type}`);
          // 如果数据中有存在开启或禁用字段enabled_status则过滤出启用数据
          if (typeData && typeData[0] && typeData[0].enabled_status) {
            typeData = typeData.filter(v => v.enabled_status === 1);
          }
          const dataList = [];
          typeData.map(item => dataList.push(Object.assign({}, item, {
            label: item.name,
            name: item.name,
            value: item.id,
          })));
          self.options = dataList;
          if (self.data !== null) {
            self.selectPack(self.data.game_pack_id);
          }
        });
    },
    selectPack(e) {
      this.options.forEach((item) => {
        if (item.id === e) {
          this.game_selected = {
            select_text: item.description,
            select_img: item.image,
            question_number: item.question_number,
            option_number: item.option_number,
            question_type: item.question_type,
          };
        }
      });
    },
    submit() {
      this.loading.submit = true;
      if (this.formData.game_pack_id === "") {
        this.$alert("请选择游戏包！");
        this.loading.submit = false;
      } else if (this.formData.name === "") {
        this.$alert("请填写游戏名称！");
        this.loading.submit = false;
      } else {
        const configList = this.$refs.configData.config.list;
        const formData = { ...this.formData, config: configList };
        // console.log(formData)
        this.$form_submit({
          id: this.formData.id,
          uri: "/game",
          data: formData,
        })
          .then(() => {
            this.$emit("success", this.formData.id);
            this.cancel();
          })
          .catch(this.$form_errorAlert)
          .finally(() => {
            this.loading.submit = false;
          });
      }
    },
    cancel() {
      this.$emit("update:visible", false);
      this.game_selected = "";
    },
  },
};
</script>

<template>
  <el-dialog
    v-if="formData"
    :show-close="false"
    :visible="visible"
    width="90%"
    class="game-list-editor"
  >
    <div slot="title">
      {{ isCreate ? '创建模板' : '编辑模板' }}
    </div>

    <!-- 自己的recorder游戏 -->
    <el-form
      ref="form"
      :model="formData"
      label-width="6em"
    >
      <el-row class="select_box">
        <el-col :span="12">
          <el-form-item
            label="游戏包"
          >
            <el-select
              v-model="formData.game_pack_id"
              filterable
              placeholder="请选择"
              @change="selectPack">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item
            label="简介"
            class="intro"
          >
            <div>{{ game_selected.select_text }}</div>
          </el-form-item>
          <el-form-item
            label="游戏名称"
          >
            <el-input
              v-model="formData.name"
              :autosize="true"
              type="textarea"
              resize="none"
              placeholder="请输入游戏名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="游戏封面图"
          >
            <div class="config_game_img">
              <img
                :src="game_selected.select_img"
                alt="">
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        class="config_box"
        label="游戏配置"
        required
      >
        <!--选择题-->
        <PlayConfig
          v-if="game_selected.question_type === 1"
          ref="configData"
          :list="data"
          :question="game_selected"/>
        <!--录音题-->
        <SpeakConfig
          v-if="game_selected.question_type === 2"
          ref="configData"
          :list="data"
          :question="game_selected"/>
        <!--录音题-->
        <SpellConfig
          v-if="game_selected.question_type === 3"
          ref="configData"
          :list="data"
          :question="game_selected"/>
        <!--听音看图题-->
        <ListenConfig
          v-else-if="game_selected.question_type === 4"
          ref="configData"
          :list="data"
          :question="game_selected"/>
        <!--判断题-->
        <TrueOrFalseConfig
          v-else-if="game_selected.question_type === 5"
          ref="configData"
          :list="data"
          :question="game_selected"/>

      </el-form-item>
    </el-form>

    <AppFormSubmit
      slot="footer"
      :submitting="loading.submit"
      @submit="submit"
      @cancel="cancel"
    />
  </el-dialog>
</template>

<style lang="postcss">
  /* 重置element-ui */

  .game-list-editor .el-form-item__content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
  }

  .game-list-editor .el-input {
  //flex-grow: 1;
  }

  .game-list-editor .el-input__inner {
    border-radius: var(--bd-radius);
  }

  /* 组件样式 */

  .game-list-editor__recorder .app-create-label {
    margin-right: 10px;
  }

  .game-list-editor__recorder .iconfont {
    font-size: 20px;
    margin: 0 10px;
  }

  .game-list-editor__recorder:nth-child(2)
  .el-form-item__content > .app-icon {
    visibility: hidden;
  }

  .game-list-editor__recorder-append {
    margin-bottom: 0 !important;
  }

  .game-list-editor__recorder-append .el-form-item__content {
    margin-left: 20px !important;
    display: flex;
    justify-content: center;
  }

  .game-list-editor__control.el-button {
    margin-left: 20px;
  }
  .config_game_img{
    width: 150px;
    height: 150px;
    text-align: center;
  }
    .config_game_img img{
      max-width: 100%;
      max-height: 100%;
    }
    .config_box{
        width: 100%;
        height: auto;
    }
  .config_box .el-form-item__content{
      height: auto !important;
  }
  .config_box .app-qiniu {
      margin-left: 0 !important;
  }
  .intro .el-form-item__content{
    height: auto !important;
  }
</style>
